@if (this.stateService.exports.hasValue()) {
  @let exports = this.stateService.exports.value();

  @if (exports.length === 0) {
    <p class="text-content-secondary">
      {{ 'CONSENSUS.EXPORT.NO_EXPORTS' | translate }}
    </p>
  }

  <div class="max-h-80 overflow-y-auto">
    @for (export of exports; track export.id) {
      <div
        class="flex items-center gap-2.5"
        [attr.data-testid]="'consensus-export-row-' + export.id"
      >
        <pm-form-input-checkbox
          [ngModel]="selectedExportId() === export.id"
          [disabled]="export.status !== ExportStatus.COMPLETED"
          (ngModelChange)="
            selectedExportId.set(
              selectedExportId() === export.id ? undefined : export.id
            )
          "
          class="shrink-0"
          [attr.data-testid]="'consensus-export-row-checkbox-' + export.id"
        />

        @let exportIsLoading =
          export.status === ExportStatus.PENDING ||
          export.status === ExportStatus.PROCESSING;
        @if (exportIsLoading) {
          <pm-icon
            [icon]="loaderIcon"
            size="sm"
            class="text-content-secondary animate-spin shrink-0"
          />
        }

        @if (export.status === ExportStatus.FAILED) {
          <pm-icon
            [icon]="errorIcon"
            size="sm"
            class="text-content-critical shrink-0"
          />
        }

        <span
          class="flex-1 text-sm text-content-interactive-subdued truncate min-w-0"
        >
          {{ export.fileName ?? '' }}
        </span>

        <span class="text-xs text-content-interactive-subdued shrink-0">
          {{
            this.dateUtilsService.formatDateTimeBasedOnLanguage(
              export.createdAt
            )
          }}
        </span>
      </div>
    }
  </div>
}
